import { useMutation } from '@tanstack/react-query';
import { checkFundingApprovalCode } from '../services/fundingApprovalCheck';
import { readInvoiceRejection } from '../services/invoiceRejection';
import { useBalanceRejectionRefresh } from './useBalanceRejectionRefresh';
import type { FundingPurpose, InvoiceLinePayload } from '../types/agreements.types';

interface CheckVariables {
    approvalId: string;
    purpose: FundingPurpose;
    lines: InvoiceLinePayload[];
    code: string;
}

export function useCheckFundingCodeMutation(agreementId: string | undefined) {
    const refreshBalance = useBalanceRejectionRefresh();

    return useMutation<void, unknown, CheckVariables>({
        mutationFn: ({ approvalId, purpose, lines, code }) =>
            checkFundingApprovalCode(agreementId ?? '', approvalId, purpose, lines, code),
        onError: (error) => refreshBalance(agreementId, readInvoiceRejection(error)),
    });
}
